import { getPublicEnvironmentVariables } from '@module/mdrt-org/shared/utils/helpers/get-public-environment-variables';
import { getStringWithQueryParameters } from '@module/mdrt-org/shared/utils/helpers/get-string-with-query-parameters';
import { fetchWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/fetch-with-error-handling';

import {
  type GetCompanyApprovedMembersRequest,
  type GetCompanyApprovedMembersResult,
} from './types';

export const getCompanyApprovedMembers = async (
  accessToken?: string,
  requestData?: GetCompanyApprovedMembersRequest,
  signal?: AbortSignal
) => {
  const publicEnvironmentVariables =
    typeof window === 'undefined' ? await getPublicEnvironmentVariables() : window.PUBLIC_ENV;

  const { sortAscending, ...restRequestData } = requestData ?? {};

  const urlWithSearchParameters = getStringWithQueryParameters(
    `${publicEnvironmentVariables.apiBaseUrl}/${publicEnvironmentVariables.companyAdminRoute}/CompanyAdmin/CompanyListings/ApprovedMembers`,
    { ...restRequestData, sortAscending: sortAscending?.toString() }
  );

  if (!accessToken) {
    throw new Error('Access token is not available');
  }

  return await fetchWithErrorHandling<GetCompanyApprovedMembersResult>(urlWithSearchParameters, {
    cache: 'no-store',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Ocp-Apim-Subscription-Key': publicEnvironmentVariables.ocpCompanyAdminSubscriptionKey ?? '',
    },
    signal,
  });
};
